interface StarData {
  number: number;
  name: string;
  id: string | number;
  avatar?: string;
}

type StreakStarsProps = {
  starsArray: StarData[];
};

import StreakStar from "./StreakStar";

const StreakStars = ({ starsArray }: StreakStarsProps) => {
  const sortedArray = starsArray.sort((a, b) => b.number - a.number);

  return (
    <div className="streakstars-box">
      <h3>Streak Stars</h3>
      {sortedArray.map((star) => {
        return (
          <StreakStar
            key={star.id}
            streakNumber={star.number}
            name={star.name}
            id={String(star.id)}
            avatar={star.avatar}
          />
        );
      })}
    </div>
  );
};
export default StreakStars;
